import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { DataService } from '@app/_services/data.service';
import { map } from 'rxjs/operators';
import { InventoryFoundAsset } from '@app/_models/_DTOs/inventoryFoundAsset';

@Injectable({ providedIn: 'root' })
export class InventoryFoundAssetService extends DataService<InventoryFoundAsset> {
    constructor(http: HttpClient) {
        super(http, "api/InventoryFoundAsset")
    }
}